// extracted by mini-css-extract-plugin
export default {"popupCopied":"Setup_popupCopied__2pqu5"};